<template>
	<div class="sld_address_list">
		<!-- <MemberTitle :memberTitle="L['收货地址']"></MemberTitle> -->
		<div class="add_default_con">
			<p class="title">{{ L['我的地址'] }}</p>
			
		</div>
		<div class="address_list_con">
			<!-- <p class="title mange">{{ L['全部地址'] }}</p> -->
			<div class="flex_row_start_center">
				
				<!-- <div class="address_item" v-if="default_address.data.length > 0"
					:style="{ backgroundImage: 'url(' + addressbg2 + ')' }">
					<div class="defalut_edit flex_row_between_center">
						<span class="red">{{ L['默认地址'] }}</span>
						<div class="oprate">
							<i class="iconfont iconbianji pointer" @click="editAddress(default_address.data[0])"></i>
						</div>
					</div>
					<div class="name_phone">
						<span class="name">{{ default_address.data[0].memberName }}</span>
						<span class="phone">{{ default_address.data[0].telMobile }}</span>
					</div>
					<div class="add_info" :title="default_address.data[0].addressAll">{{
						default_address.data[0].addressAll }}</div>
					<div class="add_detail overflow_ellipsis_two" :title="default_address.data[0].detailAddress">
						{{ default_address.data[0].detailAddress }}
					</div>
				</div> -->
				
			</div>
			<div class="container flex_row_start_center">
				<div class="add_address flex_column_center_center pointer" @click="addAddress">
					<i class="iconfont iconxinzengdizhi"></i>
					<p>{{ L['添加新地址'] }}</p>
				</div>
				<div v-for="(addressItem, index) in address_list.data" :key="index" class="address_item"

				 @mouseover="hoverIndex = index"
         @mouseleave="hoverIndex = null"
					>
					
					<div class="name_phone flex_row_start_start">
						<span class="name">{{ addressItem.memberName }}</span>
						<span class="phone">{{ addressItem.telMobile }}</span>
						<span class="red" v-if="addressItem.isDefault == 1">{{
							 L['默认地址'] 
						}}</span>
					</div>
					<div class="add_info">
						{{ addressItem.addressAll }}{{ addressItem.detailAddress }}</div>
					<!-- <div class="add_info" :title="addressItem.addressAll">{{ addressItem.addressAll }}</div>
					<div class="add_detail overflow_ellipsis_two" :title="addressItem.detailAddress">
						{{ addressItem.detailAddress }}
					</div> -->
					<div  class="defalut_edit flex_row_between_center"  style="position: relative;">
						<div class="oprate" v-if="hoverIndex === index">
							<span @click="setDefault(addressItem.addressId)"
							v-if="addressItem.isDefault != 1">{{ L['设为默认'] }}</span>
							<span  @click="editAddress(addressItem)">{{ L['编辑'] }}</span>
							<span  @click="delBox(addressItem.addressId)">{{ L['删除'] }}</span>
							
					
						</div>
						 <!-- 自定义确认弹框 -->
						<!-- <div @mouseleave="handleMouseLeave" v-if="showConfirmDialog[addressItem.addressId] " class="confirm-dialog-overlay">
							<div class="confirm-dialog flex_column_center_center">
								<p class="confirm-title">{{ L['确认删除该地址吗？'] }}</p>
								<div class="confirm-buttons flex_row_center_center">
									<div @click="handleCancel(addressItem.addressId)" class="confirm-button cancel">
										{{ L['取消'] }}
									</div>
									<div @click="handleConfirm(addressItem.addressId)" class="confirm-button confirm">
										{{ L['删除'] }}
									</div>
								</div>
							</div>
							
						</div> -->

					</div>

				</div>
			</div>

			<!-- <div class="empty" v-if="address_list.data.length == 0">
        <img src="@/assets/acode_empty.png" alt="">
        <div>暂无数据哦</div>
      </div> -->
			<!-- <SldCommonEmpty v-if="address_list.data.length == 0" :tip="L['暂无收货地址～']" totalHeight="300" totalWidth="934" /> -->
		</div>
	</div>
	<SldAddressOperation v-if="addressVisibleFlag" @close="close" @refreshAddress="refreshAddress" :visibleFlag="true"
		:type="type" :addressInfo="addressInfo" />
</template>
<script>
import { ElMessage, ElMessageBox,ElPopconfirm } from 'element-plus'
import { ref, getCurrentInstance, reactive, onMounted } from 'vue'
import SldAddressOperation from '../../components/AddressOperation'
import SldCommonEmpty from '../../components/SldCommonEmpty'
import MemberTitle from '../../components/MemberTitle'
export default {
	name: 'MemberAddressList',
	components: {
		SldAddressOperation,
		SldCommonEmpty,
		MemberTitle,
		ElPopconfirm,
		ElMessageBox
	},
	setup() {
		const addressVisibleFlag = ref(false)
		const { proxy } = getCurrentInstance()
		const L = proxy.$getCurLanguage()
		const hoverIndex = ref(null)
		const addressbg = require('../../assets/addressbg.png')
		const addressbg2 = require('../../assets/addressbg2.png')
		const address_list = reactive({ data: [] })
		const default_address = reactive({ data: [] })
		const addressInfo = reactive({ data: {} })
		const selectedAddress = ref(null)
		const type = ref('add')

		 // 使用对象存储每个地址项的确认框显示状态
		 const showConfirmDialog = ref({});

		// 处理删除按钮点击事件
		const handleDeleteClick = (addressId) => {
			// 显示当前地址项的确认框
			showConfirmDialog.value = { [addressId]: true };
		};

		// 处理确认事件
		const handleConfirm = (addressId) => {
			delAddress(addressId); // 执行删除操作
			showConfirmDialog.value = { [addressId]: false }; // 关闭当前地址项的确认框
		};

		// 处理取消事件
		const handleCancel = (addressId) => {
			showConfirmDialog.value = { [addressId]: false }; // 关闭当前地址项的确认框
		};
		 // 处理鼠标移出事件
		 const handleMouseLeave = () => {
      showConfirmDialog.value = false; // 关闭弹框
    };


		//点击添加地址事件
		const addAddress = () => {
			type.value = 'add'
			addressVisibleFlag.value = true
		}
		//编辑地址事件
		const editAddress = address => {
			addressInfo.data = address
			type.value = 'edit'
			addressVisibleFlag.value = true
		}
		//关闭弹窗
		const close = () => {
			addressVisibleFlag.value = false
		}
		//获取地址列表
		const getAddressList = () => {
			proxy
				.$get('v3/member/front/memberAddress/list', {
					pageSize: 1000
				})
				.then(res => {
					if (res.state == 200) {
						address_list.data = res.data.list
						default_address.data = res.data.list.filter(function (item) {
							return item.isDefault == 1
						})
					} else {
						ElMessage(res.msg)
					}
				})
				.catch(() => {
					//异常处理
				})
		}
		//删除地址
		const delAddress = addressId => {
			proxy
					.$post('v3/member/front/memberAddress/del', {
						addressIds: addressId
					})
					.then(res => {
						if (res.state == 200) {
							ElMessage.success(res.msg)
							getAddressList()
						} else {
							ElMessage(res.msg)
						}
					})
			// ElMessageBox.confirm(L['确认删除该地址吗？'], L['提示'], {
			// 	confirmButtonText: L['确定'],
			// 	cancelButtonText: L['取消'],
			// 	type: 'warning'
			// }).then(() => {
				
			// })
		}
		//设为默认
		const setDefault = addressId => {
			proxy
				.$post('v3/member/front/memberAddress/changeDefaultAddress', {
					addressId: addressId,
					isDefault: 1
				})
				.then(res => {
					if (res.state == 200) {
						ElMessage.success(res.msg)
						getAddressList()
					} else {
						ElMessage(res.msg)
					}
				})
				.catch(() => {
					//异常处理
				})
		}
		const refreshAddress = () => {
			getAddressList()
		}
		const selectAddress = (index) => {
      selectedAddress.value = index;
    };

		const delBox = (e) =>{
			proxy
					.$confirm(L['确定删除该地址?'], L['提示'], {
						confirmButtonText: L['确定'],
						cancelButtonText: L['取消'],
						type: 'warning',
						customClass:'cancel_collect'
					})
					.then(() => {
						handleConfirm(e)
					})
					.catch(() => { })
			
		}
		onMounted(() => {
			getAddressList()
		})
		return {
			addressVisibleFlag,
			delBox,
			addAddress,
			addressbg,
			addressbg2,
			L,
			address_list,
			default_address,
			delAddress,
			showConfirmDialog,
			handleDeleteClick,
			handleCancel,
			handleConfirm,
			// handleVisibleChange,
			refreshAddress,
			type,
			addressInfo,
			editAddress,
			close,
			setDefault,
			selectAddress,
			selectedAddress,
			hoverIndex,
			handleMouseLeave
		}
	}
}
</script>
<style lang="scss" scoped>
@import '../../style/addressList.scss';
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 0 200px 0;
  > img {
    width: 120px;
    height: 120px;
    -webkit-user-drag: none;
    // user-drag: none;
  }
  > div {
    margin-top: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 15px;
    color: #888e98;
    line-height: 24px;
  }
}
::v-deep.sld_address_list{
	.add_info {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
/* 选中样式 */
// .address_item.selected {
//   border: 1px solid #1E7CFF; /* 蓝色边框 */
// }
.address_item:hover {
    border-color: #1E7CFF; /* 悬浮时边框变为蓝色 */
}
// .defalut_edit {
//     display: none; /* 默认隐藏按钮 */
//     position: absolute;
//     right: 10px;
//     top: 10px;
// }

// .address_item:hover .defalut_edit {
//     display: flex; /* 悬浮时显示按钮 */
// }

.oprate{
display: flex;
}

/* 使用 :deep() 来修改内部样式 */
.el-popconfirm .el-button--primary{
  width: 100px;
	height: 34px;
	background: #1E7CFF!important;
	border-radius: 2px 2px 2px 2px;
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 400;
	font-size: 15px;
	color: #FFFFFF;
}

.el-popconfirm .el-button--text{
  width: 100px;
	height: 34px;
	border-radius: 1px 1px 1px 1px;
	border: 1px solid #E0E0E0;
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 400;
	font-size: 15px;
	color: #888E98;
	
}

.el-popconfirm .el-popconfirm__main{
	font-family: Microsoft YaHei,Microsoft YaHei;
	font-weight: 400;
	font-size: 15px;
	color: #000000;
	line-height: 24px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 20px;
	margin-bottom: 30px;
}
.el-popover.el-popper{
		width: 269px;
		height: 125px;
		display: flex;
    justify-content: center;
    align-items: flex-start;
		padding: 0px;
}
}

.confirm-dialog-overlay{
	position: absolute;
	bottom: 30px;
	// left: -88px;
	right: -129px;
	
	.confirm-dialog{
		// position: relative;
		width: 285px;
		height: 138px;
		background-image: url('../../assets/del_con.png');
		background-size: cover;
		background-repeat: no-repeat;
		// background-position: center center;
		// background: #FFFFFF;
		// box-shadow: 0px 8px 16px 0px rgba(84,86,96,0.05);
		// border-radius: 0px 0px 0px 0px;
		// border: 0.5px solid #888E98;
		// border: 1px solid #E0E0E0;
		
		.confirm-title{
			font-weight: 400;
			font-size: 15px;
			color: #000000;
			line-height: 24px;
		}
		.confirm-buttons{
			margin-top: 30px;
			.confirm-button{
				width: 100px;
				height: 34px;
				font-weight: 400;
				font-size: 15px;
				line-height: 24px;
				text-align: center;
				line-height: 32px;
				cursor: pointer;
			}
			.confirm{
				border-radius: 2px;
				color: #FFFFFF;
				background: #1E7CFF;
			}
			.cancel{
				border-radius: 1px;
				color: #888E98;
				border: 1px solid #E0E0E0;
				margin-right: 20px;
			}
		}
		// .tr{
		// 	position: absolute;
		// 	bottom: 0;
		// 	right: 50%;
		// 	width: 0;
		// 	height: 0;
		// 	border-style: solid;
		// 	border-width: 20px;
		// 	border-color: #962020 transparent transparent transparent; /* 下、右、上、左 */
		// }
	}
}
</style>
